<template>
  <div class="staff-list-page">
    <page-title>{{ $t('employees.list') }}</page-title>
    <user-list pageBaseUrl="/users/list"></user-list>
  </div>
</template>
<script>
import UserList from '@/components/Users/UserList/List.vue'
export default {
  components: {
    UserList
  }
}
</script>

